/* eslint-disable jsx-a11y/media-has-caption */

import React, { useRef, useState } from 'react';
import Image from 'next/image';
import PropTypes from 'prop-types';

const VideoWithThumbnail = ({
  video, width, height, layout, objectFit, notPlayable, smallerPlayButton, onPlay = () => {}, onPause = () => {},
}) => {
  const [isActivated, setIsActivated] = useState(false);
  const playerRef = useRef();

  const styles = {
    container: {
      // height: layout ? '100%' : height, // Apparently Next.js' Image component doesn't enforce height, so we don't either
      height: layout && '100%',
      width: layout && '100%',
    },
    thumbnailOverlay: {
      width: smallerPlayButton ? '2rem' : '5rem',
      height: smallerPlayButton ? '2rem' : '5rem',
    },
    thumbnailOverlayIcon: {
      fontSize: smallerPlayButton ? '1rem' : '3rem',
      marginLeft: smallerPlayButton ? '2px' : '6px',
    },
  };

  const activate = () => {
    if (!notPlayable) {
      setIsActivated(true);
    }
  };

  return (
    <div className="im-video-with-thumbnail" style={styles.container}>
      {isActivated ? (
        <video
          className="im-video-with-thumbnail__video"
          ref={playerRef}
          src={video.file}
          {...(width ? { width, height } : {})}
          controls
          controlsList="nodownload"
          autoPlay
          onPlay={() => onPlay(playerRef)}
          onPause={() => onPause(playerRef)}
        />
      ) : (
        <>
          <Image
            src={video.thumbnail}
            {...(layout ? { layout, objectFit } : { width, height })}
          />
          <div className="im-video-with-thumbnail__thumbnail-overlay-container" onClick={() => activate()}>
            <div className="im-video-with-thumbnail__thumbnail-overlay" style={styles.thumbnailOverlay}>
              <i className="im-video-with-thumbnail__thumbnail-overlay-icon fa-solid fa-play" style={styles.thumbnailOverlayIcon} />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

VideoWithThumbnail.propTypes = {
  video: PropTypes.object,
  width: PropTypes.string,
  height: PropTypes.string,
  layout: PropTypes.string,
  objectFit: PropTypes.string,
  notPlayable: PropTypes.bool,
  smallerPlayButton: PropTypes.bool,
  onPlay: PropTypes.func,
  onPause: PropTypes.func,
};

export default VideoWithThumbnail;
